
import React, { useState, useEffect, useRef } from "react";
import PopupForm from "../../../Components/PopupForm";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { Badge, Box, Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuditDetailView from "./AuditDetailView";
import { useSelector } from "react-redux";
const cookies = new Cookies();



export default function AuditViewContainer(props) {
  const [t] = useTranslation("common");
  const navigate = useNavigate();
  const [reload, setReload] = useState(false)
  const maintheme = useSelector((state) => state.themeData.maintheme);



  useEffect(() => {
    //TODO load transactionAudit grid data

  }, [props?.openForm, props?.object]);








  return (
    <PopupForm
      open={props?.openForm}
      setOpen={props?.setOpenForm}
      title={t("TRANSACTIONS.transaction_audit_details")}
      isFullScreen={false}

      content={<Box className="Container-fluid position-relative" sx={{ flexGrow: 1 }}>

        <Grid container spacing={2} sx={{
          marginTop: '10px'
        }}>

          <Grid xs={12} sm={12} md={12} lg={12} sx={{
            padding: '0px',

          }}>
            <Box sx={{
              paddingTop: '10px'
            }}>
              <AuditDetailView
                reload={reload}
                transactionAuditId={props?.object?.id}
              />
            </Box>

          </Grid>
        </Grid>

      </Box>

      }
      footer={
        <Box>

          <Button

            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "120px !important",
              minWidth: "120px !important",
              maxWidth: "120px !important",
              backgroundColor: maintheme?.secondary,
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props?.setOpenForm(false);
            }}
          >
            {t("GLOBAL.ok")}
          </Button>

        </Box>

      }
    />
  );
}
